export default "__VITE_ASSET__D95EtPKe__"